import trackerDataTableItemNotes
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemNotes/TrackerDataTableItemNotes'

export default {
  name: 'TrackerDataTableItemNotesMobile',
  mixins: [trackerDataTableItemNotes]
}
